module.exports = __webpack_public_path__ + "img/Desk Stationary A24.8d2d900c.jpg";